import { render, staticRenderFns } from "./select-integral-remark.vue?vue&type=template&id=284fef13"
import script from "./select-integral-remark.vue?vue&type=script&lang=ts"
export * from "./select-integral-remark.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports